import { CategoryDto, CategoryModel } from '../../data-layer/business/types';
import { CategoryUI } from '../../ui/business/types';

export const fromCategoriesTreeDto = (categories: CategoryDto[]): CategoryModel[] =>
    categories.map((category) => {
        const result: CategoryModel = {
            id: category.id,
            name: category.display_name,
        };

        if (category.children) {
            result.children = fromCategoriesTreeDto(category.children);
        }

        return result;
    });

export const toCategoryUI = (category: CategoryModel): CategoryUI => category;
